import { useSuspenseQuery } from '@tanstack/react-query';
import { airportsIdTafGet } from '@/api/core/airports/airportsIdTafGet';

export const useAirportTaf = (id: number) => useSuspenseQuery({
    queryKey: ['airportTaf', id],
    queryFn: () => airportsIdTafGet(id).then(r => r.payload)
});
